/**
 * @flow
 * @relayHash 466bffefc006c36386132aaa3ba01c11
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ContractDetails_contract$ref = any;
export type ContractSetCachePriceMutationVariables = {|
  contractId: string,
  price: any,
|};
export type ContractSetCachePriceMutationResponse = {|
  +factsetSetCachePrice: ?{|
    +contract: ?{|
      +$fragmentRefs: ContractDetails_contract$ref
    |}
  |}
|};
export type ContractSetCachePriceMutation = {|
  variables: ContractSetCachePriceMutationVariables,
  response: ContractSetCachePriceMutationResponse,
|};
*/


/*
mutation ContractSetCachePriceMutation(
  $contractId: ID!
  $price: Decimal!
) {
  factsetSetCachePrice(contractId: $contractId, price: $price) {
    contract {
      ...ContractDetails_contract
      id
    }
  }
}

fragment ContractDetails_contract on ContractNode {
  id
  symbol
  currency
  imageUrl
  createdAt
  updatedAt
  ibStatus
  ibConId
  instrumentType
  name
  exchange {
    symbol
    id
  }
  latestPriceBase
  latestPriceLocal
  latestPriceDate
  latestPriceTime
  priceIncrements {
    increment
    lowEdge
  }
  priceCashInfo {
    timeSet
    timeOfPrice
    price
    source
    currency
  }
  contractmarketdatarequestSet {
    edges {
      node {
        id
      }
    }
  }
  fsContract {
    id
    isin
    name
    country
    industry
    sedol
    sector
    lotSize
    currency
    factsetlatestcontractfinancialdata {
      date
      closingPriceLocal
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "contractId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "price",
    "type": "Decimal!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "contractId",
    "variableName": "contractId"
  },
  {
    "kind": "Variable",
    "name": "price",
    "variableName": "price"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "symbol",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ContractSetCachePriceMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "factsetSetCachePrice",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCachePrice",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "contract",
            "storageKey": null,
            "args": null,
            "concreteType": "ContractNode",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "ContractDetails_contract",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ContractSetCachePriceMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "factsetSetCachePrice",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCachePrice",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "contract",
            "storageKey": null,
            "args": null,
            "concreteType": "ContractNode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "imageUrl",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "updatedAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "ibStatus",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "ibConId",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "instrumentType",
                "args": null,
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "exchange",
                "storageKey": null,
                "args": null,
                "concreteType": "ExchangeNode",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "latestPriceBase",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "latestPriceLocal",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "latestPriceDate",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "latestPriceTime",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "priceIncrements",
                "storageKey": null,
                "args": null,
                "concreteType": "PriceIncrement",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "increment",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "lowEdge",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "priceCashInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PriceCacheInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "timeSet",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "timeOfPrice",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "price",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "source",
                    "args": null,
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "contractmarketdatarequestSet",
                "storageKey": null,
                "args": null,
                "concreteType": "ContractMarketDataRequestNodeConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ContractMarketDataRequestNodeEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ContractMarketDataRequestNode",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "fsContract",
                "storageKey": null,
                "args": null,
                "concreteType": "FactsetContractNode",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isin",
                    "args": null,
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "country",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "industry",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "sedol",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "sector",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "lotSize",
                    "args": null,
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "factsetlatestcontractfinancialdata",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LatestContractFinancialDataNode",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "date",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "closingPriceLocal",
                        "args": null,
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "ContractSetCachePriceMutation",
    "id": null,
    "text": "mutation ContractSetCachePriceMutation(\n  $contractId: ID!\n  $price: Decimal!\n) {\n  factsetSetCachePrice(contractId: $contractId, price: $price) {\n    contract {\n      ...ContractDetails_contract\n      id\n    }\n  }\n}\n\nfragment ContractDetails_contract on ContractNode {\n  id\n  symbol\n  currency\n  imageUrl\n  createdAt\n  updatedAt\n  ibStatus\n  ibConId\n  instrumentType\n  name\n  exchange {\n    symbol\n    id\n  }\n  latestPriceBase\n  latestPriceLocal\n  latestPriceDate\n  latestPriceTime\n  priceIncrements {\n    increment\n    lowEdge\n  }\n  priceCashInfo {\n    timeSet\n    timeOfPrice\n    price\n    source\n    currency\n  }\n  contractmarketdatarequestSet {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  fsContract {\n    id\n    isin\n    name\n    country\n    industry\n    sedol\n    sector\n    lotSize\n    currency\n    factsetlatestcontractfinancialdata {\n      date\n      closingPriceLocal\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ce6323d39d2bc55a78b897cd3cb62708';
module.exports = node;
